import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=4f72191e&scoped=true"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"
import style0 from "./popover.vue?vue&type=style&index=0&id=4f72191e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f72191e",
  null
  
)

export default component.exports